import React from 'react';
import PropTypes from 'prop-types';
import { Editor, EditorProvider } from 'react-simple-wysiwyg';

const TextEditor = ({ value, onChange }) => {
  const handleChange = (e) => {
    onChange(e.target.value); // Pass updated HTML to parent
  };

  return (
    <div>
     <EditorProvider>
      <Editor value={value} onChange={handleChange} />
    </EditorProvider>
    </div>
  );
};

TextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextEditor;